<template>
  <div class="home">
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit">
      <el-col :md="5" :sm="12">
        <el-form-item label="筛选" prop="account_name">
          <el-input v-model.trim="searchForm.account_name" placeholder="渠道号" />
        </el-form-item>
      </el-col>
      <el-col :md="5" :sm="12">
        <el-form-item label="App名称" prop="app_id">
          <SelectApp v-model="searchForm.app_id"></SelectApp>
        </el-form-item>
      </el-col>
      <el-col :md="5" :sm="12">
        <el-form-item label="广告平台" prop="platform">
          <el-select v-model="searchForm.platform" filterable clearable multiple collapse-tags
            :popper-append-to-body="false" placeholder="请选择">
            <el-option v-for="item in platform" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="5" :sm="12">
        <el-form-item label="筛选时间">
          <!-- <el-date-picker
            v-model="searchForm.time"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            :clearable="false"
            :popper-append-to-body="false"
            unlink-panels
          /> -->
          <dataPicker :datevalue.sync="searchForm.time"></dataPicker>
        </el-form-item>
      </el-col>
    </FilterLayout>
    <TableLayout :column="column" :data="tableData.data" :total="tableData.total" :loading="tableData.loading"
      :currentPage="tableOpt.currentPage" @sizeChange="onSizeChange" @pageChange="onPageChange">
      <template #system="row">{{ row.row.system | formatSystem }}</template>
      <template #time_add="row">{{
      $moment(row.row.time_add).format("YYYY-MM-DD HH:mm")
    }}</template>
      <template #option="row">
        <el-button size="small" @click="onShowEdit(row.row)">查看记录</el-button>
      </template>
    </TableLayout>
    <el-dialog :title="recordFormTitle" :visible.sync="showRecordForm" width="950px">
      <div class="compared">
        <div class="compared-item">
          <div class="compared-title">修改前</div>
          <el-form label-width="0px">
            <el-form-item>
              <!-- 回传比例 -->
              <div>
                <el-switch active-text="回传激活设备" v-model="beforeForm.active" disabled></el-switch>
                <span class="hcbl_title" style="margin-left: 58px">回传比例
                  <el-input class="back-money" :min="0" :max="100" type="number" v-model="beforeForm.a" disabled />%
                </span>
              </div>
              <!-- 回传类型 -->
              <div>
                <span>回传类型：</span>
                {{ beforeForm.activeBackhaulType }}
                {{ beforeForm.activeBackhaulBehaviorType ? beforeForm.activeBackhaulBehaviorType : "" }}
              </div>
              <!-- 计划ID -->
              <div>
                <span>计划ID：</span>
                <el-input type="textarea" :rows="4" v-model="beforeForm.back_active_bind_aid" class="bindid-box"
                  disabled />
              </div>
            </el-form-item>
            <el-form-item>
              <el-switch active-text="回传次日留存设备" v-model="beforeForm.keep" disabled></el-switch>
              <span class="hcbl_title" style="margin-left: 30px">回传比例
                <el-input class="back-money" :min="0" :max="100" type="number" v-model="beforeForm.b" disabled />%
              </span>
              <div>
                &ensp; &ensp;<span>回传类型：</span>
                {{ beforeForm.keepBackhaulType }}
                {{ beforeForm.keepBackhaulBehaviorType ? beforeForm.keepBackhaulBehaviorType : "" }}
              </div>
              <div>
                &ensp;&ensp;<el-switch active-text="激活回传校验" v-model="beforeForm.activation_check" disabled></el-switch>
              </div>
              <!-- 计划ID -->
              <div>
                <span>计划ID：</span>
                <el-input type="textarea" :rows="4" v-model="beforeForm.back_keep_bind_aid" class="bindid-box"
                  disabled />
              </div>
            </el-form-item>
            <el-form-item>
              <el-switch active-text="回传付费设备" v-model="beforeForm.pay" disabled></el-switch>
              <span class="hcbl_title" style="margin-left: 58px">回传比例
                <el-input class="back-money" :min="0" :max="100" type="number" v-model="beforeForm.c" disabled />%
              </span>
              <div>
                <span>回传类型：</span>
                {{ beforeForm.payBackhaulType }}
                {{ beforeForm.payBackhaulBehaviorType ? beforeForm.payBackhaulBehaviorType : "" }}
              </div>
              <!-- 计划ID -->
              <div>
                <span>计划ID：</span>
                <el-input type="textarea" :rows="4" v-model="beforeForm.back_pay_bind_aid" class="bindid-box"
                  disabled />
              </div>
              <div v-show="beforeForm.pay" class="form-item-child">
                <!-- 订单类型 -->
                <div style="padding: 10px 0" v-if="showOrderType">
                  <span class="hcbl_title">
                    <span class="hcbl_title" style="margin-right: 14px">订单类型</span>
                    <el-select disabled v-model="beforeForm.order_callback_type" placeholder="请选择">
                      <el-option v-for="item in orderCallbackType" :key="item.val" :label="item.label"
                        :value="item.val">
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <div style="padding: 10px 0">
                  <span class="hcbl_title">
                    <span class="hcbl_title" style="margin-right: 14px">自定义回传时间</span>
                    <el-input class="back-money" :min="1" type="number" v-model="beforeForm.d" disabled />
                    <el-select class="back-money" disabled v-model="beforeForm.time" placeholder="请选择">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <div>
                  <span class="hcbl_title" style="margin-right: 28px">订单金额大于</span>
                  <el-input class="back-money" type="number" disabled v-model="beforeForm.pay_money" />元时回传
                </div>
                <div style="padding-top: 10px">
                  <span class="hcbl_title">回传订单金额比例</span>
                  <el-input class="back-money" type="number" v-model="beforeForm.pay_detail" disabled />
                  %
                </div>
              </div>
            </el-form-item>
            <!-- 回传下单设备 -->
            <el-form-item v-if="showPlatform === '腾讯广告'">
              <el-switch active-text="回传下单设备" v-model="beforeForm.create_order.on" disabled></el-switch>
              <span class="hcbl_title" style="margin-left: 58px">回传比例
                <el-input class="back-money" :min="0" :max="100" type="number" v-model="beforeForm.create_order.scale"
                  disabled />%
              </span>
              <div>
                <span>回传类型：</span>
                {{ beforeForm.create_order.callback_cate }}
                {{ beforeForm.create_order.callback_cate_behavior || "" }}
              </div>
              <!-- 计划ID -->
              <div>
                <span>计划ID：</span>
                <el-input type="textarea" :rows="4" v-model="beforeForm.create_order_bind_aid" class="bindid-box"
                  disabled />
              </div>
              <div v-show="beforeForm.create_order.on" class="form-item-child">

                <div style="padding: 10px 0">
                  <span class="hcbl_title">
                    <span class="hcbl_title" style="margin-right: 14px">自定义回传时间</span>
                    <el-input class="back-money" :min="1" type="number"
                      v-model="beforeForm.create_order.custom_back_time.value" disabled />
                    <el-select class="back-money" disabled v-model="beforeForm.create_order.custom_back_time.unit"
                      placeholder="请选择">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <div>
                  <span class="hcbl_title" style="margin-right: 28px">订单金额大于</span>
                  <el-input class="back-money" type="number" disabled v-model="beforeForm.create_order.pay_fee" />元时回传
                </div>
                <div style="padding-top: 10px">
                  <span class="hcbl_title">回传订单金额比例</span>
                  <el-input class="back-money" type="number" v-model="beforeForm.create_order.pay_detail" disabled />
                  %
                </div>
              </div>
            </el-form-item>
            <!-- 回传关键行为 -->
            <div v-if="flag">
              <el-switch active-text="回传关键行为" v-model="beforeForm.action" disabled></el-switch>
              <span class="hcbl_title" style="margin-left: 58px">回传比例
                <el-input class="back-money" :min="0" :max="100" type="number" disabled v-model="beforeForm.actionNum"
                  @blur="
      beforeForm.actionNum === ''
        ? (beforeForm.actionNum = 100)
        : (beforeForm.actionNum = beforeForm.actionNum)
      " />%
              </span>
              <div>
                <span>回传类型：</span>
                {{ beforeForm.actionBackhaulType }}
                {{ beforeForm.actionBackhaulBehaviorType ? beforeForm.actionBackhaulBehaviorType : "" }}
              </div>
              <!-- 计划ID -->
              <div>
                <span>计划ID：</span>
                <el-input type="textarea" :rows="4" v-model="beforeForm.callback_behaviour_bind_aid" class="bindid-box"
                  disabled />
              </div>
              <div v-if="beforeForm.action" style="padding: 10px 0">

                <span class="hcbl_title form-item-child">
                  <span class="hcbl_title" style="margin-right: 14px">自定义回传时间</span>
                  <el-input class="back-money" :min="1" type="number" v-model="beforeForm.action_timeNum" disabled />
                  <el-select class="back-money" v-model="beforeForm.action_time" placeholder="请选择" disabled>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </span>
              </div>
            </div>
          </el-form>
        </div>
        <div class="compared-item">
          <div class="compared-title">修改后</div>
          <el-form label-width="0px">
            <el-form-item>
              <el-switch active-text="回传激活设备" v-model="afterForm.active" disabled></el-switch>
              <span class="hcbl_title" style="margin-left: 58px">回传比例
                <el-input class="back-money" :min="0" :max="100" type="number" v-model="afterForm.a" disabled />%
              </span>
              <div>
                <span>回传类型：</span>
                {{ afterForm.activeBackhaulType }}
                {{ afterForm.activeBackhaulBehaviorType ? afterForm.activeBackhaulBehaviorType : "" }}
              </div>
              <!-- 计划ID -->
              <div>
                <span>计划ID：</span>
                <el-input type="textarea" :rows="4" v-model="afterForm.back_active_bind_aid" class="bindid-box"
                  disabled />
              </div>
            </el-form-item>
            <el-form-item>
              <el-switch active-text="回传次日留存设备" v-model="afterForm.keep" disabled></el-switch>
              <span class="hcbl_title" style="margin-left: 30px">回传比例
                <el-input class="back-money" :min="0" :max="100" type="number" v-model="afterForm.b" disabled />%
              </span>
              <div>
                &ensp; &ensp;<span>回传类型：</span>
                {{ afterForm.keepBackhaulType }}
                {{ afterForm.keepBackhaulBehaviorType ? afterForm.keepBackhaulBehaviorType : "" }}
              </div>
              <div>
                &ensp; &ensp;<el-switch active-text="激活回传校验" v-model="afterForm.activation_check" disabled></el-switch>
              </div>
              <!-- 计划ID -->
              <div>
                <span>计划ID：</span>
                <el-input type="textarea" :rows="4" v-model="afterForm.back_keep_bind_aid" class="bindid-box"
                  disabled />
              </div>
            </el-form-item>
            <el-form-item>
              <el-switch active-text="回传付费设备" v-model="afterForm.pay" disabled></el-switch>
              <span class="hcbl_title" style="margin-left: 58px">回传比例
                <el-input class="back-money" :min="0" :max="100" type="number" v-model="afterForm.c" disabled />%
              </span>
              <div>
                <span>回传类型：</span>
                {{ afterForm.payBackhaulType }}
                {{ afterForm.payBackhaulBehaviorType ? afterForm.payBackhaulBehaviorType : "" }}
              </div>
              <!-- 计划ID -->
              <div>
                <span>计划ID：</span>
                <el-input type="textarea" :rows="4" v-model="afterForm.back_pay_bind_aid" class="bindid-box" disabled />
              </div>
              <div v-show="afterForm.pay" class="form-item-child">
                <!-- 订单类型 -->
                <div style="padding: 10px 0" v-if="showOrderType">
                  <span class="hcbl_title">
                    <span class="hcbl_title" style="margin-right: 14px">订单类型</span>
                    <el-select disabled v-model="afterForm.order_callback_type" placeholder="请选择">
                      <el-option v-for="item in orderCallbackType" :key="item.val" :label="item.label"
                        :value="item.val">
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <div style="padding: 10px 0">
                  <span class="hcbl_title">
                    <span class="hcbl_title" style="margin-right: 14px">自定义回传时间</span>
                    <el-input class="back-money" :min="1" type="number" v-model="afterForm.d" disabled />
                    <el-select class="back-money" disabled v-model="afterForm.time" placeholder="请选择">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <div>
                  <span class="hcbl_title" style="margin-right: 28px">订单金额大于</span>
                  <el-input class="back-money" type="number" disabled v-model="afterForm.pay_money" />元时回传
                </div>
                <div style="padding-top: 10px">
                  <span class="hcbl_title">回传订单金额比例</span>
                  <el-input class="back-money" type="number" v-model="afterForm.pay_detail" disabled />
                  %
                </div>
              </div>
            </el-form-item>
            <!-- 回传下单设备 -->
            <el-form-item v-if="showPlatform === '腾讯广告'">
              <el-switch active-text="回传下单设备" v-model="afterForm.create_order.on" disabled></el-switch>
              <span class="hcbl_title" style="margin-left: 58px">回传比例
                <el-input class="back-money" :min="0" :max="100" type="number" v-model="afterForm.create_order.scale"
                  disabled />%
              </span>
              <div>
                <span>回传类型：</span>
                {{ afterForm.create_order.callback_cate }}
                {{ afterForm.create_order.callback_cate_behavior || "" }}
              </div>
              <!-- 计划ID -->
              <div>
                <span>计划ID：</span>
                <el-input type="textarea" :rows="4" v-model="afterForm.create_order_bind_aid" class="bindid-box"
                  disabled />
              </div>
              <div v-show="afterForm.create_order.on" class="form-item-child">

                <div style="padding: 10px 0">
                  <span class="hcbl_title">
                    <span class="hcbl_title" style="margin-right: 14px">自定义回传时间</span>
                    <el-input class="back-money" :min="1" type="number"
                      v-model="afterForm.create_order.custom_back_time.value" disabled />
                    <el-select class="back-money" disabled v-model="afterForm.create_order.custom_back_time.unit"
                      placeholder="请选择">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <div>
                  <span class="hcbl_title" style="margin-right: 28px">订单金额大于</span>
                  <el-input class="back-money" type="number" disabled v-model="afterForm.create_order.pay_fee" />元时回传
                </div>
                <div style="padding-top: 10px">
                  <span class="hcbl_title">回传订单金额比例</span>
                  <el-input class="back-money" type="number" v-model="afterForm.create_order.pay_detail" disabled />
                  %
                </div>
              </div>
            </el-form-item>

            <div v-if="flag">
              <el-switch active-text="回传关键行为" v-model="afterForm.action" disabled></el-switch>
              <span class="hcbl_title form-item-child" style="margin-left: 58px">回传比例
                <el-input class="back-money" disabled :min="0" :max="100" type="number" v-model="afterForm.actionNum"
                  @blur="
      afterForm.actionNum === ''
        ? (afterForm.actionNum = 100)
        : (afterForm.actionNum = afterForm.actionNum)
      " />%
              </span>
              <div>
                <span>回传类型：</span>
                {{ afterForm.actionBackhaulType }}
                {{ afterForm.actionBackhaulBehaviorType ? afterForm.actionBackhaulBehaviorType : "" }}
              </div>
              <!-- 计划ID -->
              <div>
                <span>计划ID：</span>
                <el-input type="textarea" :rows="4" v-model="afterForm.callback_behaviour_bind_aid" class="bindid-box"
                  disabled />
              </div>
              <div v-if="afterForm.action" style="padding: 10px 0">
                <span class="hcbl_title form-item-child">
                  <span class="hcbl_title" style="margin-right: 14px">自定义回传时间</span>
                  <el-input class="back-money" :min="1" type="number" disabled v-model="afterForm.action_timeNum" />
                  <el-select class="back-money" v-model="afterForm.action_time" placeholder="请选择" disabled>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </span>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showRecordForm = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pickerOptions } from "@/config/option";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import SelectApp from "@/component/select-app";
import { mapState } from "vuex";
import { formatSystem } from "@/util/filters";

export default {
  name: "home",
  components: {
    FilterLayout,
    TableLayout,
    SelectApp,
  },
  computed: {
    ...mapState({
      App: (state) => state.app.data,
      orderCallbackType: (state) => state.dict_main.order_callback_type,
    }),
  },
  data() {
    return {
      showPlatform: "", // 当前查看详情的平台
      showOrderType: false, // 是否展示订单类型
      flag: false,
      pickerOptions,
      searchForm: {
        account_name: "",
        platform: "",
        app_id: "",
        time: [],
      },
      column: [
        {
          prop: "time_add",
          label: "操作时间",
        },
        {
          prop: "realname",
          label: "操作人",
        },
        {
          prop: "name",
          label: "账号",
        },
        {
          prop: "appid",
          label: "APPID",
        },
        {
          prop: "title",
          label: "APP名称",
        },
        {
          prop: "platform",
          label: "广告平台",
        },
        {
          prop: "channel",
          label: "渠道号",
        },
        {
          prop: "option",
          label: "操作",
        },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      tableData: {
        data: [],
        total: 0,
        loading: false,
        currentPage: 1,
        pageSize: 10,
      },
      showRecordForm: false,
      recordFormTitle: "",
      platform: [],
      beforeForm: {
        id: "",
        active: false,
        keep: false,
        keep_today: false,
        activation_check: false,//激活回传校验开关
        pay: false,
        pay_today: false,
        pay_money: 0,
        pay_detail: 0,
        a: 0,
        b: 0,
        c: 0,
        d: 1,
        time: "day",
        action: false,
        actionNum: 0,
        action_timeNum: 0,
        time: "day",
        action_time: "day",
        order_callback_type: "",
        back_active_bind_aid: "", // 绑定的回传激活设备计划ID
        back_keep_bind_aid: "", // 激活回传计划ID
        back_pay_bind_aid: "", // 付费计划ID
        callback_behaviour_bind_aid: "", // 行为计划ID
        create_order_bind_aid: "",   // 订单计划ID
        // 回传下单设备的回显
        create_order: {
          custom_back_time: {}
        }
      },
      afterForm: {
        id: "",
        active: false,
        keep: false,
        keep_today: false,
        activation_check: false,//激活回传校验开关
        pay: false,
        pay_today: false,
        pay_money: 0,
        pay_detail: 0,
        a: 0,
        b: 0,
        c: 0,
        d: 1,
        time: "day",
        action: false,
        actionNum: 0,
        action_timeNum: 0,
        time: "day",
        action_time: "day",
        order_callback_type: "",
        back_active_bind_aid: "", // 绑定的回传激活设备计划ID
        back_keep_bind_aid: "", // 激活回传计划ID
        back_pay_bind_aid: "", // 付费计划ID
        callback_behaviour_bind_aid: "", // 行为计划ID
        create_order_bind_aid: "",   // 订单计划ID
        // 回传下单设备的回显
        create_order: {
          custom_back_time: {}
        }
      },
      options: [
        {
          value: "day",
          label: "日",
        },
        {
          value: "hour",
          label: "小时",
        },
      ],
      type_options: [
      ],
      behavior_options: [
        {
          value: "1",
          label: "激活",
        },
        {
          value: "2",
          label: "注册",
        },
        {
          value: "3",
          label: "下单（普通订单）",
        },
        {
          value: "4",
          label: "下单（订阅订单）",
        },
        {
          value: "5",
          label: "下单（全部订单）",
        },
        {
          value: "6",
          label: "支付（普通订单）",
        },
        {
          value: "7",
          label: "支付（订阅订单）",
        },
        {
          value: "8",
          label: "支付（全部订单）",
        },
        {
          value: "9",
          label: "次留",
        },
        {
          value: "10",
          label: "续订",
        },
        {
          value: "11",
          label: "退单",
        },
        {
          value: "12",
          label: "投诉",
        },
      ],
      mapping_val: "",
    };
  },
  mounted() {
    this.fetchPlatform();
    this.fetchData();
    this.handleData()
  },
  methods: {
    async fetchPlatform() {
      const [err, res] = await this.$http.post("Invest_Config/get", {
        cate: 10,
      });

      if (err) return;

      this.platform = res;
    },
    async fetchData() {
      const { searchForm, tableOpt } = this;

      this.tableData.loading = true;

      const [err, res] = await this.$http.post("Invest_Config/backControlLog", {
        ...searchForm,
        ...tableOpt,
        timeBegin: this.searchForm.time[0],
        timeEnd: this.searchForm.time[1],
      });

      this.tableData.loading = false;

      if (err) return;

      const { list, currentPage, total } = res;

      this.tableData.data = list;
      this.tableData.currentPage = currentPage;
      this.tableData.total = total;
    },
    onSubmit() {
      this.tableOpt.currentPage = 1;
      this.fetchData();
    },
    onPageChange(current) {
      this.tableOpt.currentPage = current;
      this.fetchData();
    },
    onSizeChange(current) {
      this.tableOpt.pageSize = current;
      this.fetchData();
    },
    onShowEdit(data) {
      const { title, system, platform, befor_change, after_change } = data;
      this.showPlatform = platform;
      this.recordFormTitle = `${title}(${formatSystem(system)})-${platform}`;
      if (
        platform.indexOf("巨量引擎") !== -1 ||
        platform.indexOf("磁力引擎") !== -1 ||
        platform.indexOf("腾讯广告") !== -1
      ) {
        this.flag = true;
        this.showOrderType = true

        if (befor_change.callback_behaviour) {
          this.beforeForm.action = !!Number(befor_change.callback_behaviour.on);
          this.beforeForm.action_mapping_action_on = befor_change.callback_behaviour ? !!Number(befor_change.callback_behaviour.mapping_action_on) : "";
          this.beforeForm.actionNum = befor_change.callback_behaviour.scale;
          this.beforeForm.action_timeNum =
            befor_change.callback_behaviour.custom_back_time.value;
          this.beforeForm.action_time =
            befor_change.callback_behaviour.custom_back_time.unit;

        }
        if (after_change.callback_behaviour) {

          this.afterForm.action = !!Number(after_change.callback_behaviour.on);
          this.afterForm.action_mapping_action_on = after_change.callback_behaviour ? !!Number(after_change.callback_behaviour.mapping_action_on) : "";
          this.afterForm.actionNum = after_change.callback_behaviour.scale;
          this.afterForm.action_timeNum =
            after_change.callback_behaviour.custom_back_time.value;
          this.afterForm.action_time =
            after_change.callback_behaviour.custom_back_time.unit;
        }
      } else {
        this.flag = false;
        this.showOrderType = false
      }
      // 修改前
      // 解析bindid，后端返回的是数组
      this.beforeForm.back_active_bind_aid = this.getBindIDtoStr(befor_change.back_active)
      this.beforeForm.back_keep_bind_aid = this.getBindIDtoStr(befor_change.back_keep)
      this.beforeForm.back_pay_bind_aid = this.getBindIDtoStr(befor_change.back_pay)
      this.beforeForm.callback_behaviour_bind_aid = this.getBindIDtoStr(befor_change.callback_behaviour)
      this.beforeForm.create_order_bind_aid = this.getBindIDtoStr(befor_change.create_order)
      this.beforeForm.create_order.on = !!Number(befor_change.create_order?befor_change.create_order.on:0);
      console.log(1);
      // 处理激活
      this.beforeForm.active = !!Number(befor_change.back_active.on);
      this.beforeForm.keep = !!Number(befor_change.back_keep.on);
      this.beforeForm.pay = !!Number(befor_change.back_pay.on);
      this.beforeForm.pay_today = !!Number(befor_change.back_pay.today);
      this.beforeForm.pay_detail = befor_change.back_pay.pay_detail;
      this.beforeForm.pay_money = befor_change.back_pay.pay_fee;
      this.beforeForm.a = befor_change.back_active.scale;
      this.beforeForm.b = befor_change.back_keep.scale;
      this.beforeForm.c = befor_change.back_pay.scale;
      this.beforeForm.d = befor_change.back_pay.custom_back_time.value;
      this.beforeForm.order_callback_type = befor_change.back_pay.order_callback_type + '';
      this.beforeForm.a_mapping_action_on = !!Number(befor_change.back_active.mapping_action_on);
      this.beforeForm.b_mapping_action_on = !!Number(befor_change.back_keep.mapping_action_on);
      this.beforeForm.c_mapping_action_on = !!Number(befor_change.back_pay.mapping_action_on);
      for (const key in befor_change) {
        if (key === "back_active") {
          // 判断字段是否存在,不存在给予默认值
          if (befor_change[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            this.type_options.forEach(item => {
              // val转为label
              if (!isNaN(parseFloat(Number(befor_change[key].callback_cate))) && isFinite(Number(befor_change[key].callback_cate))) {
                if (item.val == befor_change[key].callback_cate) {
                  this.beforeForm.activeBackhaulType = item.label;
                }
              } else {
                this.beforeForm.activeBackhaulType = "映射回传（标准行为）";
                this.behavior_options.forEach(item => {
                  if (item.val == befor_change[key].callback_cate) {
                    this.beforeForm.activeBackhaulBehaviorType = item.label
                  }
                })

              }
            })
          } else {
            this.beforeForm.activeBackhaulType = "普通回传"
          }
        }
        if (key === "back_keep") {
          // 判断字段是否存在,不存在给予默认值
          if (befor_change[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            this.type_options.forEach(item => {
              // val转为label
              if (!isNaN(parseFloat(Number(befor_change[key].callback_cate))) && isFinite(Number(befor_change[key].callback_cate))) {
                if (item.val == befor_change[key].callback_cate) {
                  this.beforeForm.keepBackhaulType = item.label;
                }
              } else {
                this.beforeForm.keepBackhaulType = "映射回传（标准行为）";
                this.behavior_options.forEach(item => {
                  if (item.val == befor_change[key].callback_cate) {
                    this.beforeForm.keepBackhaulBehaviorType = item.label
                  }
                })

              }
            })
          } else {
            this.beforeForm.keepBackhaulType = "普通回传"
          }
          this.beforeForm.activation_check = Number(befor_change[key].activation_check) ? true : false;
        }
        if (key === "back_pay") {
          // 判断字段是否存在,不存在给予默认值
          if (befor_change[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            this.type_options.forEach(item => {
              // val转为label
              if (!isNaN(parseFloat(Number(befor_change[key].callback_cate))) && isFinite(Number(befor_change[key].callback_cate))) {
                if (item.val == befor_change[key].callback_cate) {
                  this.beforeForm.payBackhaulType = item.label;
                }
              } else {
                this.beforeForm.payBackhaulType = "映射回传（标准行为）";
                this.behavior_options.forEach(item => {
                  if (item.val == befor_change[key].callback_cate) {
                    this.beforeForm.payBackhaulBehaviorType = item.label
                  }
                })
              }
            })
          } else {
            this.beforeForm.payBackhaulType = "普通回传"
          }
        }
        if (key === "create_order") {
          // 判断字段是否存在,不存在给予默认值
          if (befor_change[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            this.type_options.forEach(item => {
              // val转为label
              if (!isNaN(parseFloat(Number(befor_change[key].callback_cate))) && isFinite(Number(befor_change[key].callback_cate))) {
                if (item.val == befor_change[key].callback_cate) {
                  this.beforeForm.create_order.callback_cate = item.label;
                }
              } else {
                this.beforeForm.create_order.callback_cate = "映射回传（标准行为）";
                this.behavior_options.forEach(item => {
                  if (item.val == befor_change[key].callback_cate) {
                    this.beforeForm.create_order.callback_cate_behavior = item.label
                  }
                })
              }
            })
          } else {
            this.beforeForm.create_order.callback_cate = "普通回传"
          }
        }

        if (key === "callback_behaviour") {
          // 判断字段是否存在,不存在给予默认值
          if (befor_change[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            this.type_options.forEach(item => {
              // val转为label
              if (!isNaN(parseFloat(Number(befor_change[key].callback_cate))) && isFinite(Number(befor_change[key].callback_cate))) {
                if (item.val == befor_change[key].callback_cate) {
                  this.beforeForm.actionBackhaulType = item.label;
                }
              } else {
                this.beforeForm.actionBackhaulType = "映射回传（标准行为）";
                this.behavior_options.forEach(item => {
                  if (item.val == befor_change[key].callback_cate) {
                    this.beforeForm.actionBackhaulBehaviorType = item.label
                  }
                })

              }
            })
          } else {
            this.beforeForm.actionBackhaulType = "普通回传"
          }
        }
      }

      // 修改后

      // 解析bindid，后端返回的是数组
      this.afterForm.back_active_bind_aid = this.getBindIDtoStr(after_change.back_active)
      this.afterForm.back_keep_bind_aid = this.getBindIDtoStr(after_change.back_keep)
      this.afterForm.back_pay_bind_aid = this.getBindIDtoStr(after_change.back_pay)
      this.afterForm.callback_behaviour_bind_aid = this.getBindIDtoStr(after_change.callback_behaviour)
      this.afterForm.create_order_bind_aid = this.getBindIDtoStr(after_change.create_order)

      // 处理回传下单的显示
      this.afterForm.create_order = after_change.create_order
      this.afterForm.create_order.on = !!Number(after_change.create_order.on);

      this.afterForm.active = !!Number(after_change.back_active.on);
      this.afterForm.keep = !!Number(after_change.back_keep.on);
      this.afterForm.pay = !!Number(after_change.back_pay.on);
      this.afterForm.pay_today = !!Number(after_change.back_pay.today);
      this.afterForm.pay_detail = after_change.back_pay.pay_detail;
      this.afterForm.pay_money = after_change.back_pay.pay_fee;
      this.afterForm.a = after_change.back_active.scale;
      this.afterForm.b = after_change.back_keep.scale;
      this.afterForm.c = after_change.back_pay.scale;
      this.afterForm.d = after_change.back_pay.custom_back_time.value;
      this.afterForm.order_callback_type = after_change.back_pay.order_callback_type + '';
      this.afterForm.a_mapping_action_on = !!Number(after_change.back_active.mapping_action_on);
      this.afterForm.b_mapping_action_on = !!Number(after_change.back_keep.mapping_action_on);
      this.afterForm.c_mapping_action_on = !!Number(after_change.back_pay.mapping_action_on);
      for (const key in after_change) {
        if (key === "back_active") {
          // 判断字段是否存在,不存在给予默认值
          if (after_change[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            this.type_options.forEach(item => {
              // val转为label
              if (!isNaN(parseFloat(Number(after_change[key].callback_cate))) && isFinite(Number(after_change[key].callback_cate))) {
                if (item.val == after_change[key].callback_cate) {
                  this.afterForm.activeBackhaulType = item.label;
                }
              } else {
                this.afterForm.activeBackhaulType = "映射回传（标准行为）";
                this.behavior_options.forEach(item => {
                  if (item.val == after_change[key].callback_cate) {
                    this.afterForm.activeBackhaulBehaviorType = item.label
                  }
                })

              }
            })
          } else {
            this.afterForm.activeBackhaulType = "普通回传"
          }
        }
        if (key === "back_keep") {
          // 判断字段是否存在,不存在给予默认值
          if (after_change[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            this.type_options.forEach(item => {
              // val转为label
              if (!isNaN(parseFloat(Number(after_change[key].callback_cate))) && isFinite(Number(after_change[key].callback_cate))) {
                if (item.val == after_change[key].callback_cate) {
                  this.afterForm.keepBackhaulType = item.label;
                }
              } else {
                this.afterForm.keepBackhaulType = "映射回传（标准行为）";
                this.behavior_options.forEach(item => {
                  if (item.val == after_change[key].callback_cate) {
                    this.afterForm.keepBackhaulBehaviorType = item.label
                  }
                })

              }
            })
          } else {
            this.afterForm.keepBackhaulType = "普通回传"
          }
          this.afterForm.activation_check = Number(after_change[key].activation_check) ? true : false

        }
        if (key === "back_pay") {
          // 判断字段是否存在,不存在给予默认值
          if (after_change[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            this.type_options.forEach(item => {
              // val转为label
              if (!isNaN(parseFloat(Number(after_change[key].callback_cate))) && isFinite(Number(after_change[key].callback_cate))) {
                if (item.val == after_change[key].callback_cate) {
                  this.afterForm.payBackhaulType = item.label;
                }
              } else {
                this.afterForm.payBackhaulType = "映射回传（标准行为）";
                this.behavior_options.forEach(item => {
                  if (item.val == after_change[key].callback_cate) {
                    this.afterForm.payBackhaulBehaviorType = item.label
                  }
                })

              }
            })
          } else {
            this.afterForm.payBackhaulType = "普通回传"
          }
        }
        if (key === "create_order") {
          // 判断字段是否存在,不存在给予默认值
          if (after_change[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            this.type_options.forEach(item => {
              // val转为label
              if (!isNaN(parseFloat(Number(after_change[key].callback_cate))) && isFinite(Number(after_change[key].callback_cate))) {
                if (item.val == after_change[key].callback_cate) {
                  this.afterForm.create_order.callback_cate = item.label;
                }
              } else {
                this.afterForm.create_order.callback_cate = "映射回传（标准行为）";
                this.behavior_options.forEach(item => {
                  if (item.val == after_change[key].callback_cate) {
                    this.afterForm.create_order.callback_cate_behavior = item.label
                  }
                })

              }
            })
          } else {
            this.afterForm.create_order.callback_cate = "普通回传"
          }
        }

        if (key === "callback_behaviour") {
          // 判断字段是否存在,不存在给予默认值
          if (after_change[key].callback_cate) {
            // 判断是否为数字,数字为一级菜单，字符串为2级
            this.type_options.forEach(item => {
              // val转为label
              if (!isNaN(parseFloat(Number(after_change[key].callback_cate))) && isFinite(Number(after_change[key].callback_cate))) {
                if (item.val == after_change[key].callback_cate) {
                  this.afterForm.actionBackhaulType = item.label;
                }
              } else {
                this.afterForm.actionBackhaulType = "映射回传（标准行为）";
                this.behavior_options.forEach(item => {
                  if (item.val == after_change[key].callback_cate) {
                    this.afterForm.actionBackhaulBehaviorType = item.label
                  }
                })

              }
            })
          } else {
            this.afterForm.actionBackhaulType = "普通回传"
          }
        }
      }
      this.showRecordForm = true;
    },

    // 获取bindID并解析为字符串
    getBindIDtoStr(obj) {
      let bind_id = ''
      if (obj && Array.isArray(obj.bind_aid)) {
        bind_id = obj.bind_aid ? obj.bind_aid.join("\n") : ""
      }
      return bind_id
    },

    async onEdit() {
      const { id, active, keep, pay, pay_today, pay_money } = this.beforeForm;

      if (!id) return;

      const [err, res] = await this.$http.post(
        "Invest_Config/editBackControl",
        {
          id: id,
          back_active: {
            on: active ? 1 : 0,
          },
          back_keep: {
            on: keep ? 1 : 0,
          },
          back_pay: {
            on: pay ? 1 : 0,
            today: pay_today ? 1 : 0,
            pay_fee: Number(pay_money).toFixed(2),
          },
        }
      );

      if (err) {
        this.$message.error("编辑失败");

        return;
      }

      this.$message.success("编辑成功");

      this.showEditForm = false;
      this.fetchData();
    },
    formatPut(code) {
      switch (String(code)) {
        case "":
          return "全部";
        case "1":
          return "是";
        case "2":
          return "否";
        default:
          return "未知";
      }
    },
    // 处理字典数据
    handleData() {
      let type_options = []; //一级菜单
      let behavior_options = [] //二级菜单
      let mapping_val = ""; //有浮窗的下拉框
      let newArr = JSON.parse(JSON.stringify(this.$store.state.dict_main.callback_cate))
      let arr = newArr.sort((a, b) => { return a.id - b.id }) //通过ID进行排序
      arr.forEach(item => {
        if (!isNaN(parseFloat(Number(item.val))) && isFinite(Number(item.val))) {
          type_options.push(item)
        } else {
          behavior_options.push(item)
        }
        if (item.label === "API映射回传（非标准行为）") {
          mapping_val = item
          return
        }
      })
      type_options.splice(1, 0, {
        label: "映射回传（标准行为）",
        val: '3',
      })
      this.type_options = type_options;
      this.behavior_options = behavior_options;
      this.mapping_val = mapping_val
    },
  },
};
</script>

<style lang="less" scoped>
.compared {
  display: flex;

  .compared-item {
    flex: 1;

    .compared-title {
      font-size: 18px;
      margin-bottom: 15px;
    }

    /deep/.el-form {
      width: 100%;
    }
  }
}

.form-item-child {
  padding-left: 20px;
}

/deep/.back-money {
  width: 100px;
  margin: 0 10px;
}

.hcbl_title {
  display: inline-block;
}

.title {
  display: inline-block;
  margin-left: 20px;
  font-size: 12px;
  color: #aaaaaa;
}

.bindid-box {
  width: 90%
}
</style>
